import { combineReducers } from 'redux';

import errors from './errors';

import {
  ACTION_LOAD_SITE_GOOGLE_TOOL__SUCCESS,
  ACTION_LOAD_SITE_GOOGLE_TOOL__REQUEST,
  ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__SUCCESS,

  ACTION_DELETE_SITE_GOOGLE_TOOL__REQUEST,
  ACTION_DELETE_SITE_GOOGLE_TOOL__SUCCESS,
  ACTION_DELETE_SITE_GOOGLE_TOOL__FAIL,
} from '../actionTypes';


const data = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_SITE_GOOGLE_TOOL__REQUEST:
    case ACTION_DELETE_SITE_GOOGLE_TOOL__SUCCESS:
      return null;

    case ACTION_LOAD_SITE_GOOGLE_TOOL__SUCCESS:
    case ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__SUCCESS:
      return action.payload.siteGoogleTool;

    default:
      return state;
  }
};

const isDeleting = (state = false, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_GOOGLE_TOOL__REQUEST:
      return true;

    case ACTION_DELETE_SITE_GOOGLE_TOOL__SUCCESS:
    case ACTION_DELETE_SITE_GOOGLE_TOOL__FAIL:
      return false;

    default:
      return state;
  }
};

export default combineReducers({
  data,
  isDeleting,
  errors,
});
